<template>
  <div class="event-form-overlay" @click.self="$emit('cancel')">
    <div class="event-form-container">
      <h4><strong>New</strong> Pull Schedule</h4>
      <p class="mt-4 mb-0">Report name and report type are required</p>

      <div class="form-card mt-3">
        <div class="report-type-name-grid">
          <div class="report-type-col">
            <div class="form-group">
              <label class="report-label">Report Type</label>
              <select
                v-model="formData.reportType"
                ref="reportType"
                @change="onChangeReportType"
                class="form-control input-height"
              >
                <option
                  v-for="(optType, index) in typesOpt"
                  :key="index"
                  :value="optType.value"
                >
                  {{ optType.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="report-name-col">
            <div class="form-group">
              <label class="report-label">Report Name</label>
              <input
                v-model="formData.reportName"
                type="text"
                ref="reportName"
                placeholder="Report Name"
                class="form-control input-height"
              />
            </div>
          </div>
        </div>

        <div v-if="formData.reportType === 'ORDER_REPORT_V_DAY' || formData.reportType === 'ORDER_REPORT_NEXT_DAY' || formData.reportType === 'ORDER_REPORT_NEXT_DAY_PLUS_1' || formData.reportType === 'ORDER_REPORT_SAME_DAY'"
          class="form-group">
          <div class="region-item">
            <div class="region-checkbox">
              <input
                v-model="formData.deliveryWindowExcluded"
                id="deliveryWindowExcluded"
                aria-describedby="comments-description"
                name="deliveryWindowExcluded" type="checkbox" class="checkbox-input">
            </div>
            <div class="region-label">
              <label for="deliveryWindowExcluded" class="checkbox-label">Delivery Window Restrict(Exclude selected delivery window)</label>
            </div>
          </div>

          <div class="regions-grid">
            <div class="region-item" v-for="(deliveryWindow, index) in deliveryWindowOpt" :key="index">
              <div class="region-checkbox">
                <input
                  :id="deliveryWindow.value"
                  v-model="formData.deliveryWindow"
                  :value="deliveryWindow.value"
                  type="checkbox"
                  class="checkbox-input"
                />
              </div>
              <div class="region-label">
                <label :for="deliveryWindow.value" class="checkbox-label">{{deliveryWindow.text}}</label>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label class="report-label">Regions (Do not select for Error/Not Pulled/Not Sent Report)</label>
          <div class="regions-grid">
            <div class="region-item" v-for="(region, index) in regionsOpt" :key="index">
              <div class="region-checkbox">
                <input
                  :id="region.value"
                  v-model="formData.deliveryRegion"
                  :value="region.value"
                  type="checkbox"
                  class="checkbox-input"
                />
              </div>
              <div class="region-label">
                <label :for="region.value" class="checkbox-label">{{region.text}}</label>
              </div>
            </div>
          </div>
        </div>

        <div class="start-end-time-grid">
          <div class="start-time-col">
            <div class="form-group">
              <label class="report-label">Default Delivery Start Time</label>
              <input
                v-model="formData.defaultDeliveryStartTime"
                type="time"
                class="form-control input-height"
              />
            </div>
          </div>
          <div class="end-time-col">
            <div class="form-group">
              <label class="report-label">Skipped Tag</label>
              <input
                v-model="formData.skippedTag"
                type="text"
                placeholder="Enter skipped order tag"
                class="form-control input-height"
              />
            </div>
          </div>
        </div>

        <div class="start-end-time-grid">
          <div class="start-time-col">
            <div class="form-group">
              <label class="report-label">Description</label>
              <input
                v-model="formData.description"
                type="text"
                class="form-control input-height"
              />
            </div>
          </div>
          <div class="end-time-col">
            <div class="form-group">
              <label class="report-label">About Arrangement Bouquet</label>
              <select
                v-model="aboutArrangement"
                class="form-control input-height"
              >
                <option
                  v-for="(optType, index) in aboutArrangementOpt"
                  :key="index"
                  :value="optType.value">{{optType.text}}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="consolidate-sort-grid">
          <div class="consolidate-col">
            <div class="form-group">
              <label class="report-label">Consolidate Order</label>
              <select
                v-model="formData.consolidateOrder"
                class="form-control input-height"
              >
                <option
                  v-for="(optType, index) in consolidateOrderOpt"
                  :key="index"
                  :value="optType.value"
                >
                  {{ optType.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="sort-col">
            <div class="form-group">
              <label class="report-label">Sort by Header Name</label>
              <select
                v-model="formData.sortHeaderName"
                class="form-control input-height"
              >
                <option
                  v-for="(optType, index) in sortHeaderNameOpt"
                  :key="index"
                  :value="optType.value"
                >
                  {{ optType.text }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="additional-report-grid">
          <div class="additional-type-col">
            <div class="form-group">
              <label class="report-label">Additional Report Type</label>
              <select
                v-model="formData.additionalReportType"
                class="form-control input-height"
                @change="onChangeAdditionalReportType"
              >
                <option
                  v-for="(optType, index) in additionalReportTypesOpt"
                  :key="index"
                  :value="optType.value"
                >
                  {{ optType.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="additional-name-col">
            <div class="form-group">
              <label class="report-label">Additional Report Name</label>
              <input
                v-model="formData.additionalReportName"
                type="text"
                placeholder="Enter Additional Report Name"
                class="form-control input-height upper"
              />
            </div>
          </div>
          <div class="additional-file-col">
            <div class="form-group">
              <label class="report-label">Additional File Type</label>
              <select
                v-model="formData.additionalFileType"
                class="form-control input-height"
              >
                <option
                  v-for="(optType, index) in additionalFileTypesOpt"
                  :key="index"
                  :value="optType.value"
                >
                  {{ optType.text }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <template v-if="!isOverride">
          <div class="regions-grid">
            <div class="region-item">
              <div class="region-checkbox">
                <input
                  id="additionPull"
                  type="checkbox"
                  class="checkbox-input"
                  v-model="formData.additionPull"/>
              </div>
              <div class="region-label">
                <label for="additionPull" class="block text-sm font-medium text-gray-700">Addition Pull</label>
              </div>
            </div>
          </div>

          <aws-cron
            v-if="!formData.additionPull"
            v-model="formData.cronText"
          />
          <div class="form-group"
            v-if="!formData.additionPull">
            <label class="mt-0 rule-label"
              >Schedule Expression(sample: cron(0 18 ? * * *))</label
            >
            <p class="text-red-400 bg-gray-800 text-align:center">Developer Purposes only</p>
            <input
              v-model="formData.cronText"
              type="text"
              placeholder=""
              class="input-height mt-1"
            />
          </div>

          <div v-if="formData.additionPull" class="start-end-time-grid">
            <label for="scheduleDate" class="mt-0 rule-label">Select Pull Schedule Date and Time</label><br>
            <div class="regions-grid">
              <div class="region-item">
                <b-form-input
                  id="input-1"
                  v-model="formData.scheduleDate"
                  type="date"
                  placeholder="Schedule Date"
                  class="input-height"
                  required
                ></b-form-input>
              </div>
              <div class="region-item">
                <b-form-input
                  id="input-1"
                  v-model="formData.scheduleTime"
                  type="time"
                  placeholder="Schedule Time"
                  class="input-height"
                  required
                ></b-form-input>
              </div>
            </div>
          </div>
        </template>

        <div class="form-buttons">
          <button class="btn btn-secondary mr-2" @click="$emit('cancel')">
            Cancel
          </button>
          <button class="btn btn-primary" @click="handleSave">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { uuid } from "vue-uuid";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);
import AWSCron from "@/components/report/aws-cron.vue";

export default {
  name: "NewScheduleForm",
  components: {
    "aws-cron": AWSCron
  },
  props: {
    isOverride: Boolean,
    consolidateOrderOpt: {
      type: Array,
      default: () => [
        { text: "False", value: false },
        { text: "True", value: true }
      ]
    },
    sortHeaderNameOpt: {
      type: Array,
      default: () => [
        { text: "Bouquet", value: "Bouquet" },
        { text: "Recipient_Name", value: "Recipient_Name" }
      ]
    },
    regionsOpt: {
      type: Array
    },
    typesOpt: {
      type: Array,
      default: () => [
        { text: "Select an option", value: "" },
        { text: "Same day Report", value: "ORDER_REPORT_SAME_DAY" },
        { text: "Next day Report", value: "ORDER_REPORT_NEXT_DAY" },
        { text: "Next day +1 Report", value: "ORDER_REPORT_NEXT_DAY_PLUS_1" },
        { text: "Specific day Report", value: "ORDER_REPORT_V_DAY" },
        { text: "Curated Gift Box Report", value: "ORDER_REPORT_NON_FLORAL_GIFTSETS" },
        { text: "Error Report", value: "ERROR_REPORT" },
        { text: "Not Pulled Report", value: "NOT_PULLED_REPORT" },
        { text: "Not Sent Report", value: "NOT_SENT_REPORT" },
        { text: "Maximum Report", value: "ORDER_REPORT_MAXIMUM" },
        { text: "Lakewood Same Day", value: "LAKEWOOD_SAME_DAY_REPORT" },
        { text: "Lakewood Next Day", value: "LAKEWOOD_NEXT_DAY_REPORT" },
        { text: "SHR Same Day", value: "SHR_SAME_DAY_REPORT" },
        { text: "SHR Next Day", value: "SHR_NEXT_DAY_REPORT" },
      ]
    },
    additionalReportTypesOpt: {
      type: Array,
      default: () => [
        { text: "Select an option", value: "" },
        { text: "Gopher Report", value: "ADDITIONAL_GOPHER_IT_REPORT" },
        { text: "Flashbox Report", value: "ADDITIONAL_FLASHBOX_REPORT" },
        { text: "Midland Report", value: "ADDITIONAL_MIDLAND_REPORT" },
        {
          text: "Go Speed Logistics Report",
          value: "ADDITIONAL_GO_SPEED_LOGISTICS_REPORT"
        }
      ]
    },
    additionalFileTypesOpt: {
      type: Array,
      default: () => [
        { text: "Select an option", value: "" },
        { text: "Excel", value: "excel" },
        { text: "CSV", value: "csv" }
      ]
    }
  },
  emits: ["save", "cancel", "error"],
  data() {
    return {
      aboutArrangement: "",
      formData: {
        id: uuid.v4(),
        cronText: "",
        additionPull: false,
        scheduleDate: "",
        scheduleTime: "",
        scheduleWeeks: [],
        reportName: "",
        description: "",
        reportType: "",
        errorCheckReport: false,
        fileType: "excel",
        deliveryDateFilterIncluded: true,
        noOfDaysToDeliveryDate: 0,
        deliveryDate: "",
        filtersForRestUrl: {
          fulfillmentStatus: "unshipped",
          fields:
            "id,name,note,discount_codes,line_items,shipping_address,shipping_lines,tags,created_at,email,note_attributes,customer",
          status: "open",
        },
        deliveryRegion: [],
        excludingRegion: [],
        provinceCode: "",
        deliveryWindowExcluded: false,
        deliveryWindow: [],
        createAtIncluded: false,
        hours: 0,
        minutes: 0,
        defaultDeliveryStartTime: "",
        skippedTag: "pulled,sent",
        consolidateOrder: false,
        sortHeaderName: "Bouquet",
        additionalReportType: "",
        additionalFileType: "",
        additionalReportName: "",
      },
      aboutArrangementOpt: [
        { text: "Regular Pull", value: "" },
        { text: "Excluding Arrangement Orders", value: "1" },
        { text: "Only Arrangement Orders", value: "2" },
      ],
      deliveryWindowOpt: [
        { text: "Late afternoon", value: ["(1pm - 5pm)", "(1pm - 6pm)", "(1pm - 7pm)", "(1pm - 8pm)",
                                        "(2pm - 5pm)", "(2pm - 6pm)", "(2pm - 7pm)", "(2pm - 8pm)",
                                        "(3pm - 5pm)", "(3pm - 6pm)", "(3pm - 7pm)", "(3pm - 8pm)"] },
        { text: "Evening", value: ["evening"] },
        { text: "Midday", value: ["midday"] },
        { text: "Midday and Evening", value: ["midday", "evening"] },
        { text: "Before Dinner", value: ["Before Dinner"] },
        { text: "After Lunch", value: ["After Lunch"] },
        { text: "Midday rush", value: ["Midday rush"] },
        { text: "Daytime rush", value: ["Daytime rush"] },
      ],
    };
  },
  watch: {
    'formData.deliveryWindow': {
      handler(newValue) {
        if (newValue && newValue.length > 0) {
          this.formData.deliveryWindowExcluded = true;
        }
      },
      deep: true
    }
  },
  methods: {
    onChangeReportType() {
      if (this.formData.reportType === "ORDER_REPORT_V_DAY" ||
          this.formData.reportType === "ORDER_REPORT_SAME_DAY" ||
          this.formData.reportType === "ORDER_REPORT_NEXT_DAY" ||
          this.formData.reportType === "ORDER_REPORT_NEXT_DAY_PLUS_1" ||
          this.formData.reportType === "ORDER_REPORT_NON_FLORAL_GIFTSETS") {
        this.formData.skippedTag = 'pulled,sent';
        this.formData.sortHeaderName = "Bouquet";
        this.formData.consolidateOrder = true;
      } else {
        this.formData.skippedTag = '';
        this.formData.consolidateOrder = false;
      }
      if (this.formData.reportType === "ORDER_REPORT_V_DAY" ||
          this.formData.reportType === "ORDER_REPORT_SAME_DAY" ||
          this.formData.reportType === "ORDER_REPORT_NEXT_DAY" ||
          this.formData.reportType === "ORDER_REPORT_NEXT_DAY_PLUS_1") {
        console.log("regular report");
      } else {
        this.formData.deliveryWindowExcluded = false;
      }

      this.formData.additionPull = this.formData.reportType === "ORDER_REPORT_V_DAY";
    },
    onChangeAdditionalReportType() {
      if (
        this.formData.additionalReportType === "ADDITIONAL_GOPHER_IT_REPORT"
      ) {
        this.formData.additionalFileType = "csv";
      } else {
        this.formData.additionalFileType = "";
        this.formData.additionalReportName = "";
      }
    },
    handleSave() {
      // if (
      //   !this.formData.reportName ||
      //   !this.formData.startTime ||
      //   !this.formData.endTime
      // ) {
      //   this.$emit("error", "Please fill in all fields");
      //   return;
      // }

      console.log(`defaultDeliveryStartTime: ${this.formData.defaultDeliveryStartTime}`);
      console.log(`defaultDeliveryStartTime2: ${this.formatTime(this.formData.defaultDeliveryStartTime)}`);

      console.log("scheduleDate:", this.formData.scheduleDate);
      console.log("scheduleTime:", this.formData.scheduleTime);

      // Generate cronText from scheduleDate and scheduleTime (AWS EventBridge format)
      if (this.formData.scheduleDate && this.formData.scheduleTime) {
        const date = dayjs(this.formData.scheduleDate);
        const time = this.formData.scheduleTime.split(":");
        const minute = time[1] || "0";
        const hour = time[0] || "0";
        const dayOfMonth = date.date();
        const month = date.month() + 1; // dayjs months are 0-indexed
        const year = date.year();

        // AWS EventBridge cron format: cron(minute hour day month dayOfWeek year)
        this.formData.cronText = `cron(${minute} ${hour} ${dayOfMonth} ${month} ? ${year})`;
        console.log("Generated cronText:", this.formData.cronText);
      }

      this.genReport();
      // this.$emit("save", { ...this.formData });
    },
    validateForm() {
      if (!this.formData.reportType) {
        const message = "Please choose report type";
        this.$refs["reportType"].focus();
        this.$emit("error", message);
        return false;
      }
      if (!this.formData.reportName) {
        const message = "Please input report name";
        this.$refs["reportName"].focus();
        this.$emit("error", message);
        return false;
      }

      if (this.formData.additionalReportType) {
        if (!this.formData.additionalReportName) {
          const message = "Please input additional report name";
          this.$refs["additionalReportName"].focus();
          this.$emit("error", message);
          return false;
        }
        if (!this.formData.additionalFileType) {
          const message = "Please choose additional file type";
          this.$refs["additionalFileType"].focus();
          this.$emit("error", message);
          return false;
        }
      }
      if (
        this.formData.reportType === "ORDER_REPORT_V_DAY" ||
        this.formData.reportType === "ORDER_REPORT_SAME_DAY" ||
        this.formData.reportType === "ORDER_REPORT_NEXT_DAY" ||
        this.formData.reportType === "ORDER_REPORT_NEXT_DAY_PLUS_1" ||
        this.formData.reportType === "ORDER_REPORT_NON_FLORAL_GIFTSETS"
      ) {
        console.log("region:", this.formData.deliveryRegion);
        if (
          !this.formData.deliveryRegion ||
          this.formData.deliveryRegion.length === 0
        ) {
          const message = "Please choose region";
          // this.$refs["cronText"].focus();
          this.$emit("error", message);
          return false;
        }
      }
      // Clear any previous errors if validation passes
      return true;
    },
    async genReport() {
      const res = this.validateForm();
      if (res === false) {
        console.log("res:", res);
        return;
      }
      this.formData.reportName = this.formData.reportName
        .trim()
        .replace(/\s/g, "_")
        .toUpperCase();
      if (this.formData.deliveryRegion.length > 0) {
        const region = this.formData.deliveryRegion[0];
        this.formData.provinceCode = (
          this.regionsOpt.find(t => {
            return t.text.toLowerCase() === region.toLowerCase();
          }) || {}
        ).provinceCode;
      }

      if (
        this.formData.reportType === "ORDER_REPORT_V_DAY" ||
        this.formData.reportType === "ORDER_REPORT_SAME_DAY" ||
        this.formData.reportType === "ORDER_REPORT_NEXT_DAY"
      ) {
        this.formData.sortHeaderName = "Bouquet";
        this.formData.consolidateOrder = true;
      }

      if (this.formData.reportType === "ORDER_REPORT_V_DAY") {
        this.formData.deliveryDateFilterIncluded = false;
        this.formData.deliveryDate = dayjs(this.deliveryDate, "YYYY-MM-DD")
          .tz("America/Winnipeg")
          .format("MM/DD/YYYY");
      }
      if (this.formData.reportType === "ORDER_REPORT_SAME_DAY") {
        this.formData.noOfDaysToDeliveryDate = 0;
      } else if (this.formData.reportType === "LAKEWOOD_REPORT") {
        this.formData.noOfDaysToDeliveryDate = 0;
      } else if (
        this.formData.reportType === "ORDER_REPORT_NEXT_DAY" ||
        this.formData.reportType === "ORDER_REPORT_MAXIMUM"
      ) {
        this.formData.noOfDaysToDeliveryDate = 1;
      } else if (this.formData.reportType === "ERROR_REPORT") {
        this.formData.errorCheckReport = true;
        this.formData.deliveryDateFilterIncluded = false;
      }
      if (this.formData.reportType === "ORDER_REPORT_NON_FLORAL_GIFTSETS") {
        this.formData.filtersForRestUrl.fields =
          "id,name,note,discount_codes,line_items,billing_address,shipping_address,shipping_lines,tags,created_at,email,note_attributes,customer";
        if (this.excludingRegions === "true") {
          this.formData.excludingRegion = this.formData.deliveryRegion;
          this.formData.deliveryRegion = [];
        }
      }

      if (this.aboutArrangement) {
        if (this.aboutArrangement === "1") {
          this.formData.excludedBouquets = [
            "The Snowfall Arrangement",
            "The Crimson Arrangement"
          ];
        } else if (this.aboutArrangement === "2") {
          this.formData.includedBouquets = [
            "The Snowfall Arrangement",
            "The Crimson Arrangement"
          ];
        }
      }

      console.log("formData:", JSON.stringify(this.formData, null, 2));
      // await this.axios.post(
      //   process.env.VUE_APP_API_ADMIN_API_ENDPOINT + "/order-pull/config",
      //   this.form,
      //   {
      //     headers: {
      //       Authorization: "Bearer " + this.$store.getters.idToken
      //     }
      //   }
      // );

      const message = "Order report submitted successfully";
      this.$emit("success", message);
    },
    getDefaultTime() {
      return dayjs().hour(16).minute(0).toDate();
    },
    getDefaultDate() {
      return dayjs().toDate();
    },
    getDateFromTimeStr(time) {
      return dayjs().hour(time.split(":")[0]).minute(time.split(":")[1]).toDate();
    },
    formatTime(time) {
      const timeObj = dayjs(time, "HH:mm");
      const timeArray = time.split(":");
      if (timeArray[1] === "00") {
        return timeObj.format("hA");
      } else {
        return timeObj.format("h:mmA");
      }
    },
  }
};
</script>

<style scoped>
/* Event form modal */
.event-form-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}

.event-form-container {
  background-color: white;
  padding: 24px;
  border-radius: 8px;
  width: 1000px;
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.form-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 20px;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  margin-bottom: 4px;
  font-weight: 500;
}

.form-control {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.form-control:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.form-card {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.report-label {
  font-weight: 600;
  color: #495057;
  margin-bottom: 8px;
}

.input-height {
  height: 38px;
}

.upper {
  text-transform: uppercase;
}

.report-type-name-grid {
  display: grid !important;
  grid-template-columns: 1fr 1fr !important;
  gap: 15px !important;
}

.report-type-col,
.report-name-col {
  min-width: 0 !important;
}

@media (max-width: 575px) {
  .report-type-name-grid {
    grid-template-columns: 1fr !important;
  }
}

.start-end-time-grid {
  display: grid !important;
  grid-template-columns: 1fr 1fr !important;
  gap: 15px !important;
}

.start-time-col,
.end-time-col {
  min-width: 0 !important;
}

@media (max-width: 575px) {
  .start-end-time-grid {
    grid-template-columns: 1fr !important;
  }
}

.consolidate-sort-grid {
  display: grid !important;
  grid-template-columns: 1fr 1fr !important;
  gap: 15px !important;
}

.consolidate-col,
.sort-col {
  min-width: 0 !important;
}

@media (max-width: 575px) {
  .consolidate-sort-grid {
    grid-template-columns: 1fr !important;
  }
}

.additional-report-grid {
  display: grid !important;
  grid-template-columns: 1fr 1fr 1fr !important;
  gap: 15px !important;
}

.additional-type-col,
.additional-name-col,
.additional-file-col {
  min-width: 0 !important;
}

@media (max-width: 768px) {
  .additional-report-grid {
    grid-template-columns: 1fr !important;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .additional-report-grid {
    grid-template-columns: 1fr 1fr !important;
  }
}

.regions-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  padding: 16px 0;
}

.region-item {
  display: flex;
  align-items: flex-start;
}

.region-checkbox {
  display: flex;
  align-items: center;
  height: 20px;
}

.checkbox-input {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 1px solid #d1d5db;
  cursor: pointer;
}

.checkbox-input:checked {
  background-color: #4f46e5;
  border-color: #4f46e5;
}

.checkbox-input:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}

.region-label {
  margin-left: 12px;
  font-size: 14px;
}

.checkbox-label {
  font-weight: 500;
  color: #374151;
  cursor: pointer;
}

@media (max-width: 768px) {
  .regions-grid {
    grid-template-columns: 1fr;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .regions-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.report-grid {
  display: grid !important;
  grid-template-columns: 1fr 1fr !important;
  gap: 15px !important;
}

.report-col {
  min-width: 0 !important;
}

.card {
  margin: 0px;
  border-radius: 0px;
}
</style>
